var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 22.1666C17.5 22.7553 17.2777 23.3223 16.8774 23.754C16.4771 24.1856 15.9285 24.45 15.3415 24.4941L15.1665 24.5H12.8332C12.2445 24.5002 11.6775 24.2778 11.2459 23.8776C10.8142 23.4773 10.5498 22.9287 10.5057 22.3416L10.4998 22.1666H17.4998ZM13.9998 2.33331C16.1173 2.33328 18.152 3.15569 19.6748 4.62707C21.1975 6.09844 22.0892 8.10375 22.1618 10.22L22.1665 10.5V14.8913L24.2922 19.1426C24.3849 19.3281 24.4314 19.5334 24.4275 19.7407C24.4236 19.9481 24.3695 20.1514 24.2698 20.3333C24.1702 20.5152 24.0279 20.6702 23.8552 20.7851C23.6825 20.9 23.4846 20.9713 23.2783 20.993L23.1442 21H4.85549C4.64801 21 4.44362 20.9498 4.25981 20.8536C4.07601 20.7573 3.91828 20.6179 3.80014 20.4474C3.682 20.2768 3.60698 20.0802 3.58149 19.8743C3.55601 19.6684 3.58083 19.4594 3.65382 19.2651L3.70749 19.1426L5.83316 14.8913V10.5C5.83316 8.33404 6.69357 6.25682 8.22512 4.72527C9.75666 3.19373 11.8339 2.33331 13.9998 2.33331Z",
    fill: "#5B58E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 4.5,
    r: 2.5,
    fill: "#37EA19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3ba67e8ab8dd768281b561d6eeaa9107.svg";
export { ForwardRef as ReactComponent };